import React, { Component } from 'react';
import Select from 'react-select';
import { LIBRARIES } from './helpers/libraryHelpers';

// class Settings extends Component {
//   render() {
//     return (
//       <div>
//         SETTINGS
//         <Select
//                   multi
//                   value={this.props.libraries}
//                   placeholder="Select your library(ies)"
//                   options={LIBRARIES}
//                   // onChange={this.handleSelectChange}
//                   onChange={this.props.settingsChange}
//                   // focusedOption={this.state.options[5]}
//                   // onFocus={this.focusHandler}
//                 />
//       </div>
//     )
//   }
// }
//
// export default Settings;



// import React, { Component } from 'react';
import styled from 'styled-components';
// import Select from 'react-select';
// import { LIBRARIES } from './helpers/libraryHelpers';
//
const Container = styled.div`
  padding: 10px;
  border-top: 1px solid lightgrey;
`
const ButtonWrapper = styled.div`
  margin: 5px 0;
  text-align: center;
  a {
    background-color: #69f;
    color: white;
    padding: 5px;
    border-radius: 5px;
    &:hover {
      background-color: #36e;
      text-decoration: none;
      color: white;
    }
  }
`
//
//
//
//
//
// class SettingsComponent extends Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       libraries: [],
//       selected: 'one',
//       options: []
//     }
//     this.handleSelectChange = this.handleSelectChange.bind(this)
//   }
//
//   componentWillReceiveProps(nextProps) {
//     this.setState({ libraries: nextProps.libraries })
//   }
//
//   componentDidMount() {
//     this.setState({
//       options: LIBRARIES
//     })
//   }
//
//   handleSelectChange (libraries) {
// 		this.setState({ libraries });
//     this.props.settingsChange(libraries)
// 	}
//
//   focusHandler(e) {
//     // COULD DO THIS WITH MUTATION OBSERVER - https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
//     window.setTimeout(function() {
//       if (document.getElementsByClassName('Select-menu-outer').length > 0) {
//         var div = document.getElementsByClassName('Select-menu-outer')[0].children[0];
//         div.scrollTop = 0;
//       }
//     }, 10)
//   }
//
//   render() {
//     return (
//       <div className='options-settings'>
//         <p>Libraries:</p>
//         <Select
//           multi
//           disabled={this.state.disabled}
//           value={this.state.libraries}
//           placeholder="Select your library(ies)"
//           options={this.state.options}
//           onChange={this.handleSelectChange}
//           focusedOption={this.state.options[5]}
//           onFocus={this.focusHandler}
//         />
//       </div>
//     );
//   }
// }
//
//
//
//
//
//

class LibsComponent extends Component {
  constructor() {
    super()
    this.state = { options: [], libraries: [] }
  }
  // componentDidUpdate() {
  //   console.log('SETTINGS UPDATE', this.state);
  // }
  componentWillReceiveProps(nextProps) {
    this.setState({ libraries: nextProps.libraries })
  }
  // handleSelectChange = (libraries) => {
	// 	this.setState({ libraries });
  //   this.props.settingsChange(libraries)
	// }
  render() {
    return (
      <Container>
        <h4>Libraries</h4>
        <div>Set here the libraries that your envelope will use. The libraries will be
          imported in your html envrionment.</div>
          <br/><p>Javascript Libraries:</p>
          <Select
                            multi
                            value={this.props.libraries}
                            placeholder="Select your library(ies)"
                            options={LIBRARIES}
                            // onChange={this.handleSelectChange}
                            onChange={this.props.libsChange}
                            // focusedOption={this.state.options[5]}
                            // onFocus={this.focusHandler}
                          />
          <br/><p>Css Libraries: Coming Soon</p>
          {/* <br/><p>Css Libraries:</p>
          <Select
            multi
            disabled={this.state.disabled}
            value={this.state.csslibraries}
            placeholder="Select your library(ies)"
            options={this.state.options}
            onChange={this.handleSelectChange}
            focusedOption={this.state.options[5]}
            onFocus={this.focusHandler}
          /> */}
        <hr />
          <p>We'll be happy to add any library (js or css) that looks like it adds to the platform.
          Mail us your suggestion and a short description, and we will be quick to implement your library in the list of options.</p>
          <ButtonWrapper><a href={"mailto:info@envelope.li"}>Suggest a new library</a></ButtonWrapper>
        <hr />
        <div>Together with the libraries that you set here, you will have access
          to the envelope API, through an object called 'envelope'. This accesses
          the data entered in the spreadsheet - like data tab. Documentation
          on this API will follow.</div>
      </Container>
    )
  }
}

export default LibsComponent;



// WEBPACK FOOTER //
// ./src/_LibsComponent.js